import MasterTable from "../../views/dashboard/widget/MasterTabel";
import {
  getGroupList,
  deleteGroup,
  updateGroupStatus,
} from "../../services/Users-services.js";
import { useGlobalState } from "../../services/hostelConst.js";
import { getOrganizationLevel } from "../../services/OrganisationServices/organizationLevel";
import React, { useEffect, useState } from "react";
import AddGroupForm from "../FormComponents/AddGroups";
import { showErrorMessages } from "../../services/utilityFunctions";
import { useNavigate } from "react-router-dom";
const GroupsTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    setIsInitialized(true);

    return () => {};
  }, []);
  return !isInitialized ? (
    <div></div>
  ) : (
    <MasterTable
      getTableData={getGroupList}
      updateStatus={updateGroupStatus}
      deleteRow={deleteGroup}
      tab1={"User Management"}
      tab2={"Groups"}
      actions={{
        status: true,
        edit: true,
        delete: true,
      }}
      AddForm={AddGroupForm}
    />
  );
};

export default GroupsTable;
